import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../state/store';
import {
  CardExpirationFilter,
  ServiceFilterType,
} from '../components/table/VehicleTable';
import { ServiceType } from '../../../codegen/vehicles';

export type OnboardingFilterState = {
  serviceFilters: (ServiceType | ServiceFilterType)[];
  cardExpirationFilter: CardExpirationFilter | undefined;
};

const initialState: OnboardingFilterState = {
  serviceFilters: [],
  cardExpirationFilter: undefined,
};

export const onboardingFilterSlice = createSlice({
  name: 'onboardingFilter',
  initialState,
  reducers: {
    setServiceFilters: (
      state,
      action: PayloadAction<(ServiceType | ServiceFilterType)[]>,
    ) => {
      state.serviceFilters = action.payload;
    },
    setCardExpirationFilter: (
      state,
      action: PayloadAction<CardExpirationFilter | undefined>,
    ) => {
      state.cardExpirationFilter = action.payload;
    },
  },
});

export const { setServiceFilters, setCardExpirationFilter } =
  onboardingFilterSlice.actions;

export const getServiceFiltersFilter = (state: RootState) =>
  state.onboardingFilter.serviceFilters;

export const getCardExpirationFilter = (state: RootState) =>
  state.onboardingFilter.cardExpirationFilter;
